import { render, staticRenderFns } from "./Asignacion.vue?vue&type=template&id=d9a10d68&scoped=true"
import script from "./Asignacion.vue?vue&type=script&lang=js"
export * from "./Asignacion.vue?vue&type=script&lang=js"
import style0 from "./Asignacion.vue?vue&type=style&index=0&id=d9a10d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a10d68",
  null
  
)

export default component.exports